<template>
  <div>
    <Nav></Nav>
    <b-container>
      <b-row>
        <b-col>
          <h1 v-if="actualProduct.id > 0">
            Personalizador
            {{ this.actualProduct.id + " " + this.actualProduct.name }}
          </h1>
          <h1 v-else>Crear Personalizador</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="actualProduct.id > 0" cols="12" class="mb-3 d-flex flex-wrap align-items-center" style="gap: 12px;">
          <img v-if="actualProduct.image" :key="actualProduct.image"
            :src="axios.defaults.baseURL + '/' + actualProduct.image" style="max-width: 128px; max-height: 128px;" />
          <image-uploader :url="'personalization/' + actualProduct.id + '/image'"
            :output-size="128" size="sm" @uploaded="onImageUploaded"></image-uploader>
        </b-col>
      </b-row>
      <b-card>
        <b-form>
          <b-row>
            <b-col md="6" sm="12">
              <b-form-group label="Nombre:">
                <b-form-input
                  v-model="actualProduct.name"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group label="Nombre corto (boton captura tactil):">
                <b-form-input
                  v-model="actualProduct.short_name"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xl="6" md="12">
              <b-form-group label="Status">
                  <b-form-checkbox v-model="actualProduct.status">
                    Activo
                  </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-button
              v-if="actualProduct.id > 0"
              block
              variant="success"
              @click="updateProduct"
              >Guardar</b-button
            >
            <b-button v-else block variant="success" @click="updateProduct">Crear</b-button>
          </b-row>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import ImageUploader from "../components/ImageUploader.vue";
export default {
  name: "Personalization",
  components: { Nav, ImageUploader },
  data() {
    return {
      actualProduct: {
        id: 0,
        name:"",
        short_name:"",
        image: "",
        image_mini: "",
        status: true,
       
      },
      
    };
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.actualProduct.id = this.$route.params.id;
      this.getProduct();
    }
  },
  methods: {
    onImageUploaded() {
      this.getProduct();
    },

    getProduct() {
      let that = this;
      axios
        .get("/personalization/" + this.actualProduct.id)
        .then(function (response) {
          that.actualProduct = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    updateProduct() {
      let that = this;
      if(this.actualProduct.id>0){
        axios
        .put("/personalization/" + this.actualProduct.id, this.actualProduct)
        .then(function (response) {
          that.actualProduct = response.data;
          that.makeToast("Exito", "exito al guardar", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
      }else{
        axios
        .post("/personalization", this.actualProduct)
        .then(function (response) {
          that.actualProduct = response.data;
          that.makeToast("Exito", "exito al crear", "success");
          that.$router.push("/personalization/"+response.data.id).catch();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
      }
      
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
